<div class="container-outer">
  <button mat-icon-button
          id="button-dialog-close"
          class="mat-icon-button-small"
          data-cy="button-dialog-close"
          mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
  <h3>{{data.title}}</h3>
  <div class="container">

    <div *ngIf="dataSource.length===0">
      <mat-spinner></mat-spinner>
    </div>

    <div>This is just a preview. Final sheet can look different.</div>

    <table mat-table [dataSource]="dataSource">

      <ng-container *ngFor="let disCol of displayedColumns; let colIndex = index" matColumnDef="{{disCol}}">
        <th mat-header-cell *matHeaderCellDef>{{disCol}}</th>
        <td mat-cell [ngStyle]="{color:isSeparatorRow(element.name)?'red':'default'}"
            *matCellDef="let element">{{element[disCol]}}</td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row [ngStyle]="{backgroundColor:isSeparatorRow(row.name)?'yellow':'white'}"
          *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div *ngIf="truncatedCount>0">
      + {{truncatedCount}} more ...
    </div>
  </div>
  <div>
    <button *ngIf="dataSource.length>0" mat-raised-button color="accent"
            class="export-confirm-button"
            (click)="downloadXLSX()">
      <ng-container *ngIf="downloading$ | async; else downloadText">
        <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="35"></mat-spinner>
      </ng-container>
    </button>
    <ng-template #downloadText>
      Download XLSX (takes a couple of seconds)
    </ng-template>
  </div>
</div>
